import { privateRequest } from "../axios";

const ENDPOINTS = {
  customerStage: "api/CRM/LeadStage",
  customerSource: "api/CRM/LeadSource",
  visitPurpose: "api/CRM/VisitPurposes",
  crmSetting: "api/CRM/CRMSetting",
  saleTargetFields: "api/SaleTargetFields",
  salesUnits: "api/Units",
  crmLead: "api/CRM/LeadType",
};

const contentTypeConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

const fetchList = async (endpoint: string) => {
  const res = await privateRequest.get(endpoint);
  return res.data;
};

const deleteItem = async (endpoint: string, id: number) => {
  const res = await privateRequest.delete(ENDPOINTS.crmLead === endpoint ? `${endpoint}?Id=${id}` : `${endpoint}/${id}`);
  return res.data;
};

const addItem = async (endpoint: string, payload: any, stringify = false) => {
  const body = stringify ? JSON.stringify(payload) : payload;
  const res = await privateRequest.post(endpoint, body, contentTypeConfig);
  return res.data;
};

const fetchCrmSetting = async (): Promise<any> => {
  const res = await privateRequest.get(ENDPOINTS.crmSetting);
  return res.data;
};

const fetchSaleTargetFields = async (): Promise<any> => {
  const res = await privateRequest.get(ENDPOINTS.saleTargetFields);
  return res.data;
};

const fetchSalesTargetUnit = async (payload: any): Promise<any> => {
  const res = await privateRequest.get(ENDPOINTS.salesUnits, {
    params: payload,
  });
  return res.data;
};

const updateCrmSetting = async (payload: any): Promise<any> => {
  const response = await privateRequest.post(ENDPOINTS.crmSetting, payload);
  return response.data;
};

const CrmSettingService = {
  fetchList,
  deleteItem,
  addItem,
  fetchCrmSetting,
  fetchSaleTargetFields,
  fetchSalesTargetUnit,
  updateCrmSetting,
  ENDPOINTS,
};

export default CrmSettingService;
